import { Badge, Box, createTheme, SxProps, Theme, ThemeProvider, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useStateContext } from "../reducers";
import { MenuCode, MenuGroupName, MenuTitle } from "../utils/Menu";
import BaseContainer from "./_BaseContainer";
import { useMemo } from "react";
import { footerHeight, formHeaderHeight, headerHeight } from "../utils/Common";
import { GridColorStyles } from "../expanded-theme";
import { FormContainerType } from "../utils/Types";

function FormContainer(props: FormContainerType) {
    const {isViewMode, editMode, title, children} = props;
    const {menuState} = useStateContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const boxHeaderStyle = useMemo<SxProps<Theme>>(() => {
        return {
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            width: "100%",
            marginTop: isMobile ? `calc(${headerHeight}px)` : "0",
            position: "fixed",
            height: `${formHeaderHeight}px`,
            zIndex: "1099",
            textAlign: "center",
            paddingX: "1.5rem",
        };
    }, [isMobile]);

    const boxFormStyle = useMemo<SxProps<Theme>>(() => {
        return {
            marginTop: `calc(${isMobile ? headerHeight + formHeaderHeight : formHeaderHeight}px)`,
            width: "100%",
            paddingX: "1.5rem",
            height: `calc(100vh - ${headerHeight + formHeaderHeight + footerHeight + (isMobile ? headerHeight : 0)}px)`,
        };
    }, [isMobile]);

    return (
        <BaseContainer>
            <Box
                sx={{...boxHeaderStyle}}
                className="bg-grid-normal"
            >
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{
                            color: "rgba(0, 0, 0, 0.6)",
                        }}
                    >
                    {
                        `Data ${title}`
                    }
                    </Typography>
                </Box>
            {
                editMode && !isViewMode ?
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        ml: "0.5rem",
                    }}
                >
                    <ThemeProvider theme={createTheme(GridColorStyles)}>
                        <Badge
                            variant="standard"
                            sx={{
                                color: "#cc1f1f",
                                borderLeft: "1px solid",
                                paddingLeft: "0.5rem",
                            }}
                        >
                            Update
                        </Badge>
                    </ThemeProvider>
                </Box>
                :
                null
            }
            </Box>
            <Box sx={{...boxFormStyle}}>
            {
                children
            }
            </Box>
        </BaseContainer>
    );
};

export default FormContainer;
